import { render } from "./SearchCustomer.vue?vue&type=template&id=7dd4e806"
import script from "./SearchCustomer.vue?vue&type=script&lang=js"
export * from "./SearchCustomer.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__